export const dataUrlToObjectUrl = (dataUrl: string): string => {
    const separatorIndex = dataUrl.indexOf(',');
    if (separatorIndex < 0) {
        throw new Error('Invalid embedded media data');
    }

    const metadata = dataUrl.slice(0, separatorIndex);
    const encodedData = dataUrl.slice(separatorIndex + 1);
    const mimeType = metadata.match(/^data:([^;,]+)/)?.[1] || 'application/octet-stream';
    const isBase64 = metadata.includes(';base64');
    const decodedData = isBase64 ? atob(encodedData) : decodeURIComponent(encodedData);
    const bytes = new Uint8Array(decodedData.length);

    for (let index = 0; index < decodedData.length; index += 1) {
        bytes[index] = decodedData.charCodeAt(index);
    }

    return URL.createObjectURL(new Blob([bytes], { type: mimeType }));
};
